import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromUser from '../reducers/user.reducer';
import {selectMyCompany} from '../../company/selectors/company.selectors';

export const selectUserState = createFeatureSelector<fromUser.UserState>(
  fromUser.userFeatureKey
);

export const selectUserPage = createSelector(
  selectUserState,
  state => state.userPage,
);

export const selectUser = createSelector(
  selectUserState,
  state => state?.activeUser,
);
export const selectUserLobsOfferingNumber = createSelector(
  selectUserState,
  state => state.activeUser?.offeringLOBs.map(lob => lob.number),
);

export const selectUserAndCompany = createSelector(
  selectUser,
  selectMyCompany,
  (user, company) => {
    return {
      user: user,
      company: company,
    };
  }
);

export const selectUserId = createSelector(
  selectUser,
  user => user?.id
);

export const selectUserLoading = createSelector(
  selectUserState,
  state => state.loading
);

export const selectUserList = createSelector(
  selectUserState,
  state => state.userList
);
